const countriesList = require("countries-list");

// COUNTRY CODES
const CANADA_ISO2 = "CA";
const ISRAEL_ISO2 = "IL";
const UNITED_STATES_ISO2 = "US";
const MEXICO_ISO2 = "MX";
const SPAIN_ISO2 = "ES";
const CHILE_ISO2 = "CL";
const PERO_ISO2 = "PE";
const ARGENTINA_ISO2 = "AR";
const BRAZIL_ISO2 = "BR";
const FRANCE_ISO2 = "FR";
const BELGIUM_ISO2 = "BE";
const GERMANY_ISO2 = "DE";
const AUSTRIA_ISO2 = "AT";
const SWITZERLAND_ISO2 = "CH";
const NETHERLANDS_ISO2 = "NL";
const ITALY_ISO2 = "IT";
const RUSSIA_ISO2 = "RU";
const JAPAN_ISO2 = "JP";
const KOREA_ISO2 = "KO";
const TURKEY_ISO2 = "TR";
const SWEDEN_ISO2 = "SV";
const POLAND_ISO2 = "PL";
const HONG_KONG_ISO2 = "HK";
const TAIWAN_ISO2 = "TW";

const NON_NATIVE_ENGLISH_COUNTRIES_ISO2 = [
  MEXICO_ISO2,
  SPAIN_ISO2,
  CHILE_ISO2,
  PERO_ISO2,
  ARGENTINA_ISO2,
  BRAZIL_ISO2,
  FRANCE_ISO2,
  CANADA_ISO2,
  BELGIUM_ISO2,
  GERMANY_ISO2,
  AUSTRIA_ISO2,
  SWITZERLAND_ISO2,
  NETHERLANDS_ISO2,
  ITALY_ISO2,
  RUSSIA_ISO2,
  JAPAN_ISO2,
  KOREA_ISO2,
  TURKEY_ISO2,
  SWEDEN_ISO2,
  POLAND_ISO2,
  HONG_KONG_ISO2,
  TAIWAN_ISO2
];

// CONTINENT CODES
const EUROPE = "EU";
const NORTH_AMERICA = "NA";

const getCountriesByContinent = (continentCode) => {
  const { countries } = countriesList;
  const countryCodes = Object.keys(countries);

  return countryCodes.filter((cc) => countries[cc].continent === continentCode);
};

const isCountryInContinent = (countryCode, continentCode) => {
  return getCountriesByContinent(continentCode).includes(countryCode);
}

module.exports = {
  // COUNTRIES ISO2
  CANADA_ISO2,
  UNITED_STATES_ISO2,
  ISRAEL_ISO2,
  NON_NATIVE_ENGLISH_COUNTRIES_ISO2,
  BRAZIL_ISO2,
  // CONTINENTS
  EUROPE,
  NORTH_AMERICA,
  // FUNCTIONS
  getCountriesByContinent,
  isCountryInContinent
};
